<div class="w-full h-full">
  <app-tab-header [tabs]="tabs"></app-tab-header>


    <div class="flex flex-row gap-10 flex-wrap justify-center">
      <div style="width: 500px; align-self: flex-start;" class="border-gray-400 b-orange">
        <header class="flex justify-between align-center p-2 b-orange-bottom font-bold orange-text">
            <h2>MAINTENANCE MODE</h2>
            <iconify-icon
              icon="mdi:information-outline"
              class="orange-text"
              style="font-size: 20px;"
              [matTooltip]="getMaintenanceTooltip"
              matTooltipPosition="above" 
              matTooltipClass="custom-orange-tooltip"
            />      
          </header>
        <div class="flex flex-row justify-between align-center gap-3 p-4">
          <app-custom-dropdown-v2
              style="width: 400px;"
              [class.opacity-50]="getAdminButtonState().disabled"
              [class.pointer-events-none]="getAdminButtonState().disabled"
              [matTooltip]="getAdminButtonState().tooltip"
              matTooltipPosition="above"
              matTooltipClass="custom-orange-tooltip"
              labelWidth="80px"
              label="Switch:"
              [options]="switchOptions"
              [selectedText]="selectedMaintenanceText"
              placeholder="== Select an option =="
              (selectionChange)="setMaintainanceMode($event.label, $event.value)"
          />

          <!-- Button centered below -->
          <span
            class="flex"
            [matTooltip]="getMaintenanceSubmitTooltip"
            matTooltipPosition="right"
            matTooltipClass="custom-orange-tooltip"
          >
            <button
              (click)="submit()"
              [disabled]="isMaintenanceSubmitDisabled()"
              [class.opacity-50]="isMaintenanceSubmitDisabled()"
              [style.cursor]="isMaintenanceSubmitDisabled() ? 'not-allowed' : 'pointer'"
              class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2"
            >
              submit
            </button>
          </span>
        </div>
      </div>

      <div style="width: 500px; align-self: flex-start;" class="border-gray-400 b-orange">
        <header class="flex justify-between align-center p-2 b-orange-bottom font-bold orange-text">
            <h2>CHECK APP VERSION</h2>
            <iconify-icon
              icon="mdi:information-outline"
              class="orange-text"
              style="font-size: 20px;"
              [matTooltip]="getCheckAppVersionTooltip"
              matTooltipPosition="above" 
              matTooltipClass="custom-orange-tooltip"
            />      
          </header>
        <div class="flex flex-row justify-between align-center gap-3 p-4">
          <app-custom-dropdown-v2
              style="width: 400px;"
              [class.opacity-50]="getAdminButtonState().disabled"
              [class.pointer-events-none]="getAdminButtonState().disabled"
              [matTooltip]="getAdminButtonState().tooltip"
              matTooltipPosition="above"
              matTooltipClass="custom-orange-tooltip"
              labelWidth="80px"
              label="Switch:"
              [options]="checkAppVersionOptions"
              [selectedText]="selectedCheckAppVersionText"
              placeholder="== Select an option =="
              (selectionChange)="setCheckAppVersionFlag($event.label, $event.value)"
          />

          <!-- Button centered below -->
          <span
            class="flex"
            [matTooltip]="getCheckAppVersionSubmitTooltip"
            matTooltipPosition="right"
            matTooltipClass="custom-orange-tooltip"
          >
            <button
              (click)="submitCheckAppVersion()"
              [disabled]="isCheckAppVersionSubmitDisabled()"
              [class.opacity-50]="isCheckAppVersionSubmitDisabled()"
              [style.cursor]="isCheckAppVersionSubmitDisabled() ? 'not-allowed' : 'pointer'"
              class="uppercase custom-btn btn-dark-orange font-semibold text-xs px-6 py-2"
            >
              submit
            </button>
          </span>
        </div>
      </div>
    </div>

</div>